import React from 'react';

export const CatalogFooter = () => (
  <footer>
      <div className="wrapper wrapper-1440 acc-desk-footer">
          <div className="footer">
              <div className="footer__col">
                  <div className="footer__logo_"> <img src="/img/logo/logo_remark_footer.svg" alt="" style={{width:"160px"}}/></div>
                  <div className="footer__soc">
                      <a href="https://www.instagram.com/remark_1991/"><img src="/img/icons/instagram.svg" alt="" style={{width:"30px"}}/></a>
                      <a href="https://www.facebook.com/remark1991"><img src="/img/icons/facebook.svg" alt="" style={{width:"40px"}}/></a>
                  </div>
              </div>
              <div className="footer__col">
                  <div className="footer__title_"> купить</div>
                      <div className="footer__linksWrap">
                          <div className="footer__links">
                              <a href="/b_designer" className="footer__link">Дизайн рубашки</a>
                              <a href="/b_catalog/formal" className="footer__link">Официальные рубашки</a>
                              <a href="/b_catalog/business" className="footer__link">Business рубашки</a>
                              <a href="/b_catalog/business_casual" className="footer__link">Business casual рубашки</a>
                              <a href="/b_catalog/casual" className="footer__link">Casual рубашки</a>
                              <a href="/suit" className="footer__link">Костюмы (Made To Measure)</a>
                              <a href="/gift" className="footer__link">Подарочный сертификат</a>
                          </div>
                      </div>
                  </div>
              <div className="footer__col">
                  <div className="footer__title_"> Товары</div>
                  <div className="footer__linksWrap">
                      <div className="footer__links">
                          <a href="/t-shit" className="footer__link">Футболки</a>
                          <a href="/polo" className="footer__link">Поло</a>
                          <a href="/hoody" className="footer__link"> Худи</a>
                          <a href="/jacket" className="footer__link">Жилеты</a>
                          <a href="/sweatshirt" className="footer__link">Свитшоты</a>
                          <a href="/ties" className="footer__link">Аксессуары</a>
                      </div>
                  </div>
              </div>
              <div className="footer__col">
                  <div className="footer__title_"> Клиентам</div>
                  <div className="footer__linksWrap">
                      <div className="footer__links">
                          <a href="/payment" className="footer__link">Оплата и доставка</a>
                          <a href="/spec" className="footer__link">Спецпредложение</a>
                          <a href="/spec#bonus" className="footer__link">Бонусная система</a>
                          <a href="/faq" className="footer__link">Вопрос-ответ</a>
                          <a href="/secondlife" className="footer__link">Вторая жизнь</a>
                          <a href="/collars" className="footer__link">Виды воротников</a>
                          <a href="/offerta.pdf" className="footer__link">Публичный договор оферты</a>
                          <a href="/public.pdf" className="footer__link">Пользовательское соглашение</a>
                      </div>
                  </div>
              </div>
              <div className="footer__col">
                  <div className="footer__title_">О нас</div>
                  <div className="footer__linksWrap">
                      <div className="footer__links">
                          <a href="/history" className="footer__link">Наша история</a>
                          <a href="/our_product" className="footer__link">Наш продукт</a>
                          <a href="/sustainability" className="footer__link">Sustainability</a>
                          <a href="/contacts" className="footer__link">Студия в Москве</a>
                          <a href="/contact" className="footer__link">Контакты</a>
                          <a href="/policy.pdf" className="footer__link">Политика конфиденциальности</a>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div className="footer__inf">
          <div className="footer acc-mob-footer">
              <div className="footer__col">
                  <div className="footer__logo_"> <img src="/img/logo/logo_remark_footer.svg" alt="" style={{width:"160px"}}/></div>
                  <div className="footer__soc">
                          <a href="https://www.instagram.com/remark_1991/"><img src="/img/icons/instagram.svg" alt="" style={{width:"30px"}}/></a>
                          <a href="https://www.facebook.com/remark1991"><img src="/img/icons/facebook.svg" alt="" style={{width:"40px"}}/></a>
                  </div>
              </div>
              <div className="footer__col">
                  <div className="footer__title_ footer__title"> купить</div>
                  <div className="footer__linksWrap">
                      <div className="footer__links">
                          <a href="b_designer" className="footer__link">Дизайн рубашки</a>
                          <a href="/b_catalog/formal" className="footer__link">Официальные рубашки</a>
                          <a href="/b_catalog/business" className="footer__link">Business рубашки</a>
                          <a href="/b_catalog/business_casual" className="footer__link">Business casual рубашки</a>
                          <a href="/b_catalog/casual" className="footer__link">Casual рубашки</a>
                          <a href="/suit" className="footer__link">Костюмы (Made To Measure)</a>
                          <a href="/gift" className="footer__link">Подарочный сертификат</a>
                      </div>
                  </div>
              </div>
              <div className="footer__col">              
                  <div className="footer__title_ footer__title"> Продукты</div>
                  <div className="footer__linksWrap">
                      <div className="footer__links">
                          <a href="/t-shirt" className="footer__link">Футболки</a>
                          <a href="/polo" className="footer__link">Поло</a>
                          <a href="/hoody" className="footer__link">Худи</a>
                          <a href="/jacket" className="footer__link">Жилеты</a>
                          <a href="/sweatshirt" className="footer__link">Свитшоты</a>
                          <a href="/ties" className="footer__link">Аксессуары</a>
                      </div>
                  </div>
              </div>
              <div className="footer__col">
                  <div className="footer__title_ footer__title"> Клиентам</div>
                  <div className="footer__linksWrap">
                      <div className="footer__links">
                          <a href="/payment" className="footer__link">Оплата и доставка</a>
                          <a href="/spec" className="footer__link">Спецпредложение</a>
                          <a href="/spec#bonus" className="footer__link">Бонусная система</a>
                          <a href="/faq" className="footer__link">Вопрос-ответ</a>
                          <a href="/secondlife" className="footer__link">Вторая жизнь</a>
                          <a href="/collars" className="footer__link">Виды воротников</a>
                          <a href="/offerta.pdf" className="footer__link">Публичный договор оферты</a>
	                  <a href="/public.pdf" className="footer__link">Пользовательское соглашение</a>
                      </div>
                  </div>
              </div>
              <div className="footer__col">
                  <div className="footer__title_ footer__title">О нас</div>
                  <div className="footer__linksWrap">
                      <div className="footer__links">
                          <a href="/history" className="footer__link">Наша история</a>
                          <a href="/our_product" className="footer__link">Наш продукт</a>
                          <a href="/sustainability" className="footer__link">Sustainability</a>
                          <a href="/contacts" className="footer__link">Студия в Москве</a>
                          <a href="/contact" className="footer__link">Контакты</a>
                          <a href="/policy.pdf" className="footer__link">Политика конфедециальности</a>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </footer>
);
